import { useContext } from 'react';
import { AuthContext } from '@/modules/auth/providers/AuthProvider.context';

export const useAuth = () => useContext(AuthContext);
